import React from 'react';

export const IdContext = React.createContext('');

export const getUniqueId = (props, propertyNames) => {
  let unique;
  let index = 0;
  do {
    unique = props[propertyNames[index]];
    index++;
  } while (!unique && index < propertyNames.length);

  return unique;
};

const withIdContext = (group = '', uniqueNameProperty = ['id', 'name']) => (WrappedComponent) => {
  const IdContextContainer = (props) => {
    const uniqueId = getUniqueId(props, uniqueNameProperty);

    const prefixes = [];
    if (group) {
      prefixes.push(group);
    }

    if (uniqueId) {
      prefixes.push(uniqueId);
    }

    const containerPrefix = prefixes.join('_');

    if (!containerPrefix) {
      return (
        <WrappedComponent {...props} />
      );
    }

    return (
      <IdContext.Consumer>
        {(prefix) => {
          const newPrefix = prefix ? `${prefix}_${containerPrefix}` : containerPrefix;

          return (
            <IdContext.Provider value={newPrefix}>
              <WrappedComponent {...props} />
            </IdContext.Provider>
          );
        }}
      </IdContext.Consumer>
    );
  };

  // copy own props to wrapped component (eg, propTypes, defaultProps, Row, Option, ...)
  Object.keys(WrappedComponent).forEach((attribute) => {
    if (Object.prototype.hasOwnProperty.call(WrappedComponent, attribute)) {
      IdContextContainer[attribute] = WrappedComponent[attribute];
    }
  });

  return IdContextContainer;
};

export default withIdContext;
